<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn color="primary" x-small text @click="() => $router.push({ name: 'home' })">
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          Planos AEE
        </h1>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card>
          <div class="text-start py-2 px-4 text-button">Pesquisa avançada</div>
          <v-divider class="theme--light"></v-divider>

          <v-row class="d-flex justify-space-between mb-6 px-4 mt-4">
            <v-col cols="12" sm="6" md="4">
              <v-text-field v-model="aluno" label="Nome do aluno" outlined dense clearable />
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-autocomplete
                :items="turmas"
                :return-object="false"
                v-model="turma"
                label="Escolha uma turma"
                item-text="descricao"
                item-value="descricao"
                outlined
                dense
                clearable
              />
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-autocomplete
                :items="$constants.bimestres"
                :return-object="false"
                v-model="bimestre"
                label="Escolha um bimestre"
                item-text="desc"
                item-value="value"
                outlined
                dense
                clearable
              />
            </v-col>
            <v-col cols="12" class="mb-5">
              <v-btn color="primary" block @click="limparFiltros">Limpar filtros</v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-col>

      <v-col>
        <v-data-table
          :loading="carregando"
          :headers="table.headers"
          :items="planos"
          :items-per-page="10"
          hide-default-footer
          class="elevation-1"
        >
          <template v-slot:body="{ items }">
            <tbody name="scroll-x-transition" is="transition-group" duration="150">
              <tr color="primary" v-for="plano of items" :key="plano.id">
                <td>{{ plano.id }}</td>
                <td>{{ plano.matricula?.aluno?.nomecompleto || "- - -" }}</td>
                <td>{{ plano.matricula?.turma?.descricao || "- - -" }}</td>
                <td>{{ plano.matricula?.turma?.turno?.descricao || "- - -" }}</td>
                <td>{{ plano.gestao_de_aula_a_e_e?.professor?.nome || "- - -" }}</td>
                <td>{{ descricaoDoBimestre(plano.bimestre) }}</td>
                <td>
                  <e-situacao-plano
                    :plano="plano"
                    servico="planosBimestraisAEEService"
                    @update="carregarPlanos(paginate.current_page)"
                  />
                </td>
                <td class="text-nowrap">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        x-small
                        class="ml-1"
                        color="primary"
                        v-bind="attrs"
                        v-on="on"
                        @click="() => abrirPlanoEmNovaAba(plano)"
                      >
                        <v-icon small>mdi-note-text-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Visualizar plano</span>
                  </v-tooltip>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        x-small
                        class="ml-1"
                        color="red lighten-5"
                        v-bind="attrs"
                        v-on="on"
                        @click="() => imprimirPlano(plano)"
                      >
                        <v-icon color="red lighten-1" small>fa fa-file-pdf</v-icon>
                      </v-btn>
                    </template>
                    <span>Imprimir plano</span>
                  </v-tooltip>
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>

        <e-paginate
          :current_page="paginate.current_page"
          :last_page="paginate.last_page"
          :pageNumber="pageNumber"
          @changeActionResponse="carregarPlanos"
        >
        </e-paginate>
      </v-col>
    </v-row>
  </main-template>
</template>

<script>
export default {
  data() {
    return {
      carregando: false,
      planos: [],
      turmas: [],
      aluno: "",
      turma: "",
      bimestre: "",
      pageNumber: 1,
      paginate: {
        current_page: 1,
        last_page: 0,
      },
      table: {
        headers: [
          { text: "#", value: "id" },
          { text: "Aluno", value: "matricula.aluno.nomecompleto" },
          { text: "Turma", value: "matricula.turma.descricao" },
          { text: "Turno", value: "matricula.turma.turno.descricao" },
          { text: "Professor do AEE", value: "gestao_de_aula_a_e_e.professor.nome" },
          { text: "Bimestre", value: "bimestre" },
          { text: "Status", value: "status" },
          { text: "Ações", value: "actions", sortable: false },
        ],
      },
    };
  },
  watch: {
    aluno() {
      this.carregarPlanos(1);
    },
    turma() {
      this.carregarPlanos(1);
    },
    bimestre() {
      this.carregarPlanos(1);
    },
  },
  async mounted() {
    await this.carregarPlanos(this.pageNumber);
    await this.listarTurmas();
  },
  methods: {
    async carregarPlanos(numeroDaPagina = null) {
      this.carregando = true;
      try {
        const pagina = numeroDaPagina || this.pageNumber;
        const payload = await this.$services.planosBimestraisAEEService.index(
          pagina,
          this.aluno ?? "",
          this.turma ?? "",
          // bimestre 0 é válido, então só omitimos quando o filtro está realmente vazio
          this.bimestre === "" || this.bimestre === null ? "" : this.bimestre
        );
        this.planos = payload.data;
        this.paginate = payload;
      } catch (error) {
        this.$handleError(error);
      }
      this.carregando = false;
    },
    async listarTurmas() {
      try {
        this.turmas = await this.$services.planosBimestraisAEEService.turmas();
      } catch (error) {
        this.$handleError(error);
      }
    },
    descricaoDoBimestre(bimestre) {
      const item = this.$constants.bimestres.find((b) => b.value === bimestre);
      return item ? item.desc : "- - -";
    },
    abrirPlanoEmNovaAba(plano) {
      const url = this.$router.resolve({
        name: "educacaoInclusiva.planosAEEVisualizar",
        params: { id: plano.id },
      }).href;
      window.open(url, "_blank");
    },
    async imprimirPlano(plano) {
      this.$loaderService.open("Gerando plano bimestral AEE...");
      try {
        await this.$services.planosBimestraisAEEService.pdf(plano.matricula_id, plano.bimestre);
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
    limparFiltros() {
      this.aluno = "";
      this.turma = "";
      this.bimestre = "";
    },
  },
};
</script>

<style></style>
